// extracted by mini-css-extract-plugin
export default {"button":"style_button__Akll0","icon":"style_icon__ZL4BD"};